import dayjs from 'dayjs';
import { formatMoney } from '../../../utils/currency';

export const fmtAmount = (v, doviz) => formatMoney(v, doviz);

export const fmtDate = (v) => (v ? dayjs(v).format('DD.MM.YYYY') : '');
